import { render, staticRenderFns } from "./DocNav.vue?vue&type=template&id=668f1008&scoped=true&"
import script from "./DocNav.vue?vue&type=script&lang=js&"
export * from "./DocNav.vue?vue&type=script&lang=js&"
import style0 from "./DocNav.vue?vue&type=style&index=0&id=668f1008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f1008",
  null
  
)

export default component.exports